export function updateBusinessTypeReducer(state, { business }) {
  return {
    ...state,
    business
  };
}
